import { FieldWrapper, FormTextField } from "styles/formStyleComponents";
import InfoIconWithTooltip from "./InfoIconWithTooltip";

const TextFieldComponent = ({
  name,
  label,
  placeholder,
  value,
  required,
  disabled,
  error,
  info,
  onChange,
  onFieldBlur,
  validation = {},
  compact = false,
}) => {
  const fieldLabel = required ? `${label}` : label;

  const textField = (
    <FormTextField
      label={compact ? undefined : fieldLabel}
      variant="outlined"
      size="small"
      fullWidth
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete="off"
      value={value || ""}
      onChange={(e) => {
        const val = e.target.value;
        if (validation.maxLength && val.length > validation.maxLength) {
          return;
        }
        onChange(name, val);
      }}
      onBlur={(e) => {
        if (onFieldBlur) {
          onFieldBlur(name, e.target.value);
        }
      }}
      error={!!error}
      helperText={error}
      slotProps={{
        htmlInput: {
          maxLength: validation.maxLength,
        },
      }}
      InputProps={{
        endAdornment: <InfoIconWithTooltip info={info} />,
      }}
    />
  );

  if (compact) {
    return textField;
  }

  return (
    <FieldWrapper>
      {textField}
    </FieldWrapper>
  );
};

export default TextFieldComponent;

